define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/header/kbMenu/kbMenuModel",
  "./topicResponseSourceModalView",
], function (Marionette, Backbone, Messenger, KbMenuModel, TopicResponseSourceModalView) {
  "use strict";
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicResponseSourceEditorModal";
    },
    show: function (options) {
      this.model = new Backbone.Model({
        response: options.responseSource,
      });
      this.view = new TopicResponseSourceModalView.topicResponseSourceModalView({
        model: this.model,
      });
      this.showRegion(this.view);
    },
  });
});
